import { Component } from '@angular/core';

@Component({
  selector: 'about-locations',
  templateUrl: 'about-locations.html'
})
export class AboutLocationsPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-locations/about-locations.ts